<template>
  <div class="box2-page">
    <pageTitle title="短视频热度不减<br/>助推个人目标快速达成" titleColor="#4d1f28" />
    <ul class="cotent">
      <li>
        <a>创业老板-</a>
        <i>有货源，流量高涨，生意爆火！</i>
      </li>
      <li>
        <a>稳定上班族-</a>
        <i>无货源能带货，发展副业高收入！</i>
      </li>
      <li>
        <a>领域达人-</a>
        <i>经验分享，轻松变现！</i>
      </li>
      <li>
        <a>自由职业人-</a>
        <i>不入职场，灵活拿高薪！</i>
      </li>
      <li>
        <a>运营新人-</a>
        <i>企业账号流量好，月月绩效高！</i>
      </li>
      <li>
        <a>全职宝妈-</a>
        <i>带娃、创收两不误！</i>
      </li>
      <li>
        <a>有志青年-</a>
        <i>建设家乡，助力农村发展！</i>
      </li>
    </ul>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  name: '',
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.box2-page {
  padding: 78px 0;
  background: url("../../../assets/coursePage/newMedia2/box2/bg.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.cotent {

  height: 926px;
  margin: 49px 30px 0;
  background-color: #ffffff;
  box-shadow: 0px 10px 20px 0px #f0e1e6;
  border-radius: 20px;
  padding: 30px;
  box-sizing: border-box;

  li {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img01.png");
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 98px;
    margin: 0 auto 30px;
    display: flex;
    align-items: center;
    padding-left: 93px;
    box-sizing: border-box;

    a {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #4d1f28;
    }

    i {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #665256;
    }
  }

  li:nth-child(2) {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img02.png");
  }

  li:nth-child(3) {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img03.png");
  }

  li:nth-child(4) {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img04.png");
  }

  li:nth-child(5) {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img05.png");
  }

  li:nth-child(6) {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img06.png");
  }

  li:nth-child(7) {
    background-image: url("../../../assets/coursePage/newMedia2/box2/img07.png");
  }

}</style>